import { Image } from "@src/components/Image";
import React from "react";

import { t } from "i18next";
import { getAwsAssets } from "@src/utils";

function LiveClassRecordingCases({ content }) {
  return (
    <div style={{ marginTop: "5px" }}>
      <div className="CourseRecordings__Item__Content__Details">
        <Image
          src={getAwsAssets("ProfileIcon.svg", "content")}
          alt="lockIcon"
          height={16}
          width={16}
        />
        <p>
          <span>
            {t(
              "components.tabs.content.components.contentList.liveClassRecordingCases.facultyText",
              "Faculty"
            )}
          </span>{" "}
          : {content?.tutorName}
        </p>
      </div>
      <div className="CourseRecordings__Item__Content__Details">
        <Image
          src={getAwsAssets("ClockIcon.svg", "content")}
          alt="lockIcon"
          height={16}
          width={16}
        />
        <p>
          <span> {content?.emblem3?.text}</span>
        </p>
      </div>
    </div>
  );
}

export default LiveClassRecordingCases;
